import { render, staticRenderFns } from "./DeleteModel.vue?vue&type=template&id=22ee53ae&scoped=true&"
import script from "./DeleteModel.vue?vue&type=script&lang=js&"
export * from "./DeleteModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee53ae",
  null
  
)

export default component.exports